/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 03 2024
 **/

import { PropsWithChildren, forwardRef } from "react";
import { ChatSystemRenderer } from "@/frameworks/core/components";

type SystemProps = {
	contents: ChatServices.Format2.Container.System;
	variant: ChatUI.Size;
} & Partial<Omit<WebServices.Chat.Messages.Data["content"][number], "content">>;

const System = forwardRef<HTMLLIElement, PropsWithChildren<SystemProps>>(({ contents, variant, ...message }, ref) => {
	return (
		<li
			css={{
				width: "-webkit-fill-available"
			}}
			ref={ref}
		>
			<ChatSystemRenderer
				systemForm={contents.elements[0] as ChatServices.Format2.Elements.AllSystemElements}
				variant={variant}
				{...message}
			/>
		</li>
	);
});

export default System;
